import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../App.css";

export default class Visdev extends Component {
  render() {
    return (
      <>
        <Row>
          <Col xs={1} sm={2} md={1} lg={2} xl={1}></Col>
          <Col xs={22} sm={20} md={22} lg={20} xl={22}>
            <Row>
              <Col span={24} className="projectTitle">
                Visual Development Projects
              </Col>
              <Col span={24} className="projectSubTitle">
                Stories and World Building
              </Col>
              <Col span={24} className="rH50"></Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" size="small">
                  <Link to="/TangTen">
                    <div className="shadowDiv">
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/TangTenCover.jpg`}
                        loading="lazy"
                        className="img100"
                        alt="Tang and Ten Image"
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                      />
                    </div>
                  </Link>
                  <div className="paddTop10 f1-5EM color00">Tang & Ten</div>
                  <div className="lh1-5EM color110">
                    <div>China Tang Dynasty Magic. Adventure</div>
                    <div>
                      The story of a girl is transported into the world of a
                      book, where an unexpected battle leads to an unlikely
                      friendship with a dragon.
                    </div>
                  </div>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" size="small">
                  <Link to="/Monster">
                    <div className="shadowDiv">
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/MonsterCover.jpg`}
                        loading="lazy"
                        className="img100"
                        alt="Tang and Ten Image"
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                      />
                    </div>
                  </Link>
                  <div className="paddTop10 f1-5EM color00">Monster's Chef</div>
                  <div className="lh1-5EM color110">
                    <div>Shanghai Concession 1940. Fantasy</div>
                    <div>
                      The Story of a talented village girl becomes a maid for a
                      family of elite monsters. awakening their world with the
                      vibrant flavors of her traditional cuisine.
                    </div>
                  </div>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" size="small">
                  <Link to="/Faceless">
                    <div className="shadowDiv">
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/FacelessCover.jpg`}
                        loading="lazy"
                        className="img100"
                        alt="Tang and Ten Image"
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                      />
                    </div>
                  </Link>
                  <div className="paddTop10 f1-5EM color00">
                    The Faceless Maiden
                  </div>
                  <div className="lh1-5EM color110">
                    <div>Folktale Recreation, Medieval Russian</div>
                    <div>
                      The story of a beautiful but vain maiden has her face
                      stolen by a demon.
                    </div>
                  </div>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col xs={1} sm={2} md={1} lg={2} xl={1}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
